module.exports = __webpack_public_path__ + "media/assets/images/events/productivity-74ac34dc4c4c797f0bcfc675c222b04c.png";